/* Display-only adapter for Releasit. Order prices and submission stay app-owned. */
(() => {
  const products = new Map();
  const seen = new WeakSet();
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
  let form = null;
  let pending = false;
  const formObserver = new MutationObserver(schedule);

  function collectProducts() {
    document.querySelectorAll('[data-ma-cod-product]').forEach(node => {
      if (seen.has(node)) return;
      seen.add(node);
      try {
        const data = JSON.parse(node.textContent);
        if (data.id && Array.isArray(data.variants)) products.set(String(data.id), data);
      } catch { /* An incomplete section must not interrupt checkout. */ }
    });
  }

  function matchingVariant(row) {
    const title = normalize(row.querySelector('.rsi-product-item-name')?.textContent);
    const matches = [...products.values()].filter(product => normalize(product.title) === title);
    if (matches.length !== 1) return null;
    const product = matches[0];
    if (product.variants.length === 1) return { product, variant: product.variants[0] };
    const option = normalize(row.querySelector('.rsi-product-item-image img')?.alt);
    const variants = product.variants.filter(variant => normalize(variant.title) === option);
    return variants.length === 1 ? { product, variant: variants[0] } : null;
  }

  function decoratePrice(row) {
    const prices = row.querySelector('.rsi-product-item-prices');
    if (!prices) return;
    const match = matchingVariant(row);
    let extra = prices.querySelector('[data-ma-cod-savings]');
    const original = prices.querySelector('.rsi-product-item-original-price');
    const amount = (original?.textContent || '').match(/\d[\d,]*(?:\.\d+)?/);
    const displayed = amount ? Number(amount[0].replace(/,/g, '')) : NaN;
    const quantity = Math.max(1, Number(row.querySelector('.rsi-quantity-input')?.value) || 1);
    // If the app applies another price, do not attach a misleading comparison.
    const isUnit = match && Math.abs(displayed * 100 - match.variant.price) < 1;
    const isLine = match && Math.abs(displayed * 100 - match.variant.price * quantity) < 1;
    if (!match || !['INR'].includes(match.product.currency) || !(match.variant.compare > match.variant.price) || !(isUnit || isLine)) {
      extra?.remove();
      return;
    }
    const { product, variant } = match;
    const multiplier = isUnit ? 1 : quantity;
    const money = amount => new Intl.NumberFormat('en-IN', {style:'currency',currency:product.currency,maximumFractionDigits:2}).format(amount / 100);
    const percentage = Math.round((variant.compare - variant.price) / variant.compare * 100);
    const signature = `${variant.id}:${variant.price}:${variant.compare}:${multiplier}`;
    if (extra?.dataset.signature === signature) return;
    if (!extra) {
      extra = document.createElement('span');
      extra.dataset.maCodSavings = '';
      extra.className = 'ma-cod-savings';
      prices.append(extra);
    }
    extra.dataset.signature = signature;
    const compare = document.createElement('s');
    compare.className = 'ma-cod-compare';
    compare.textContent = money(variant.compare * multiplier);
    const badge = document.createElement('span');
    badge.className = 'ma-cod-discount';
    badge.textContent = `${percentage}% off · Save ${money((variant.compare - variant.price) * multiplier)}`;
    extra.replaceChildren(compare, badge);
  }

  function enhance() {
    pending = false;
    if (!form?.isConnected) return;
    formObserver.disconnect();
    try {
      collectProducts();
      const input = form.querySelector('#first_name');
      if (input) {
        if (input.placeholder !== 'Full name') input.placeholder = 'Full name';
        if (input.autocomplete !== 'name') input.autocomplete = 'name';
        const label = form.querySelector('label[for="first_name"]');
        // Preserve the app's required marker and React-owned label structure.
        if (label) {
          const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
          while (walker.nextNode()) {
            const node = walker.currentNode;
            const next = node.nodeValue.replace(/first\s+name/gi, 'Full name');
            if (next !== node.nodeValue) node.nodeValue = next;
          }
        }
      }
      form.querySelectorAll('.rsi-product-item-wrapper').forEach(decoratePrice);
    } finally {
      formObserver.observe(form, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['value','placeholder']});
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(enhance);
  }

  function connect() {
    const next = document.getElementById('rsi_form_wrapper');
    if (next === form) return;
    formObserver.disconnect();
    form = next;
    if (form) {
      form.addEventListener('input', schedule);
      schedule();
    }
  }

  function start() {
    collectProducts();
    connect();
    new MutationObserver(records => {
      // Ignore edits inside the popup: the scoped observer handles those.
      if (records.some(record => !form?.contains(record.target))) connect();
    }).observe(document.body, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
